export const zh = {
    Number: '计划单据编号',
    MSVNumber: 'MSV单据编号',
    Year: '拜访年份',
    Type: '供应商类型',
    Category: '类型',
    SupplierFacility: '供应商工厂',
    ResponsibleCQS: 'CQS负责人',
    OverallRiskLevel: '风险水平',
    CreateUser: '创建人',
    CreateDate: '创建时间',
    Remark: '备注',
    addVisitPlan: '新增年度拜访计划',
    Frequency: '拜访频率',
    UpdateUser: '更新人',
    UpdateDate: '更新时间',
    noEmpty: '不能为空',
    FactoryNo: '工厂编号',
    FactoryName: '工厂名称',
    SupplierNo: '供应商编号',
    SupplierName: '供应商名称',
    SerialNumber: '序号',
    ReportStatus: '报告状态',
    VisitPlan: '拜访计划',
    VisitReport: '拜访报告',
    ApprovalPass: '审批通过',
    ApprovalReject: '审批拒绝',
    selectRow: '请选择一行数据',
    PleaseSupplierType: '请先选择供应商类型',
    selectFile: '整改报告附件上传到服务器后才能提交',
    PlanDetailsStatus: '计划明细状态',
    PlanStatus: '计划状态',
    VisitDate: '拜访日期',
    mgtRecap: '拜访总结',
    visitPurpose: '拜访目的',
    ReportDetails: '报告明细',
    ModifyLog: '修改日志',
    AddPlanDetails: '计划明细新增',
    OnlyPdf: '只能上传pdf格式的文件',
    OnlyPdfOne: '只能上传一个文件',
    ReportBy: 'Report by',
    draftSave: '存为草稿',
    operationTips:'"存为草稿"按钮，仅做数据保存并未提交；若确认信息无误，请点击"提交"按钮'
}

export const en = {
    Number: 'Number',
    MSVNumber: 'MSV Number',
    Year: 'Year',
    Type: 'Type',
    Category: 'Category',
    SupplierFacility: 'Supplier Facility',
    ResponsibleCQS: 'Responsible CQS',
    OverallRiskLevel: 'Overall Risk Level',
    CreateUser: 'Create User',
    CreateDate: 'Create Date',
    Remark: 'Remark',
    addVisitPlan: 'New annual non notice visit plan',
    Frequency: 'Frequency',
    UpdateUser: 'Update User',
    UpdateDate: 'Update Date',
    noEmpty: 'Can not be empty',
    FactoryNo: 'Factory No',
    FactoryName: 'Factory name',
    SupplierNo: 'Supplier No',
    SupplierName: 'Supplier Name',
    SerialNumber: 'Serial number',
    ReportStatus: 'Report status',
    VisitPlan: 'Visit plan',
    VisitReport: 'Visit Report',
    ApprovalPass: 'Approval Pass',
    ApprovalReject: 'Approval Reject',
    selectRow: 'Please select a row of data',
    PleaseSupplierType: 'Please select supplier type first',
    selectFile: 'The rectification report can only be submitted after the attachment is uploaded to the server',
    PlanDetailsStatus: 'Plan details status',
    PlanStatus: 'Plan status',
    VisitDate: 'Date of visit',
    mgtRecap: 'Summary of visits',
    visitPurpose: 'Purpose of visit',
    ReportDetails: 'Report details',
    ModifyLog: 'Modification log',
    AddPlanDetails: 'Add plan details',
    OnlyPdf: 'Only files in PDF format can be uploaded',
    OnlyPdfOne: 'Only one file can be uploaded',
    ReportBy: 'Report by',
    draftSave: 'Save as draft',
    operationTips:'"Save as draft" button, just save the data without submitting; if you confirm that the information is correct, please click the "Submit" button'
}